import { Component, OnInit, Optional, Inject } from '@angular/core';
import { EditDialogsXmldefsService } from './edit-dialogs-xmldefs.service';
import { DialogsAlertComponent } from '../../../../../../../shared/components/dialogs/dialogs-alert/dialogs-alert.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import * as _ from 'lodash';

@Component({
  selector: 'app-edit-dialogs-xmldefs',
  templateUrl: './edit-dialogs-xmldefs.component.html',
  styleUrls: ['./edit-dialogs-xmldefs.component.scss']
})
export class EditDialogsXmldefsComponent implements OnInit {

  /** Subscripción para el guardado de un xmldef */
  $guardar!: Subscription;

  loading: boolean = true;
  defaultLabel: string = "";
  selectedItemsLabel: string = "";
  styleFormat = {width: '100%'};

  constructor(@Optional() @Inject(MAT_DIALOG_DATA) public data: any,
              public editDialogsXmldefsService: EditDialogsXmldefsService,
              @Optional() private dialogRef: MatDialogRef<EditDialogsXmldefsComponent>,
              private translateService: TranslateService,
              private dialog: MatDialog) { this.editDialogsXmldefsService.build(); }

  ngOnInit() {
    this.editDialogsXmldefsService.init(this.data).subscribe(result => {
      this.loading = false;
    });
  }

  /**
  * @description
  * Guardar el Xmldef
  */
  guardar() {
    this.loading = true;
    this.$guardar = this.editDialogsXmldefsService.guardar().subscribe(value => {
      console.log(value);
      // -2: El número del xmldef está ausente
      // -1: El número del xmldef ya existe
      // false: Error al guardar
      if (value === -1 || value === false || value === -2) {
        this.errorXmldefs('WARNINGS.error_nuevo');
      }
       this.loading = false;
    }, error => {
      console.log(error);
      this.errorXmldefs('WARNINGS.error_nuevo');
      this.loading = false;
    });
  }

  /**
  * @description
  * Cierra el dialog xmldefs
  */
  aceptar() {
    this.dialogRef.close(true);
  }

  /**
  * @description
  * Deshabilita o habilita el botón aceptar
  */
  deshabilitar(){
    let xmldef = this.editDialogsXmldefsService.xmldefs;
    let original = this.editDialogsXmldefsService.originalXmldefs;
    return this.editDialogsXmldefsService.compare(xmldef, original);
  }

  /**
  * @description
  * Abre un cuadro de dialogo para informar de un error
  * @param error Texto a mostrar
  */
  public errorXmldefs(error: string) {
    const dialogRef = this.dialog.open(DialogsAlertComponent, {
      disableClose: true,
      hasBackdrop: true,
      data: { texto: this.translateService.instant(error) }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
    });
  }

}
